<template>
  <div v-if="hasMessage" class="campaign-navigation-area">
    <div class="campaign-navigation-area__content">
      <p class="campaign-navigation-area__message">
        {{ message }}
      </p>
      <a
        class="campaign-navigation-area__link text-link"
        @click="scrollToDetail"
      >
        詳細をみる
      </a>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CampaignNavigationArea',
  props: {
    message: {
      type: String,
      required: false,
      default: ''
    },
    campaignDetailId: {
      type: String,
      required: true
    },
    scrollOffset: {
      type: Number,
      required: false,
      default: 140
    }
  },
  computed: {
    hasMessage() {
      return this.message && this.message.trim() !== ''
    }
  },
  methods: {
    scrollToDetail() {
      const element = document.getElementById(this.campaignDetailId)
      if (element) {
        const elementTop = element.getBoundingClientRect().top
        // getBoundingClientRect() メソッドで取得できる位置はスクロールを考慮しないスクリーン上の位置のため、
        // スクロール量である window.pageYOffset を考慮してページ内での位置を求める
        const pageYOffset = window.pageYOffset
        // header の height 分を引く
        window.scrollTo({
          top: elementTop + pageYOffset - this.scrollOffset,
          behavior: 'smooth'
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.campaign-navigation-area {
  &__content {
    background-color: $primary-lighten;
    display: flex;
    padding: 8px 16px;
    align-items: center;
    gap: 8px;
    align-self: stretch;
  }

  &__message {
    @extend %caption-bold;
    color: $brown-1;
    width: 100%;
  }

  &__link {
    @extend %caption;
    color: $link;
    flex-shrink: 0;
  }
}
</style>
